






































































import { Component, Vue } from 'vue-property-decorator'
import Glass from '@/data/glass'
import CartItem, { ICartItem } from '@/store/models/CartItem'
import GlassType from '@/data/glass-type'
import DefaultButton from './ui/DefaultButton.vue'
import OfferTile from './ui/OfferTile.vue'
import NavigationButtons from './ui/NavigationButtons.vue'
import ShoppingCart from './ShoppingCart.vue'
import { Offer } from '@/data/enums'
import { mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapGetters('cart', ['totalPrice'])
  },

  components: {
    OfferTile,
    DefaultButton,
    NavigationButtons,
    ShoppingCart
  }
})
export default class CartOverview extends Vue {
  private image: string = 'style/cart/cart.png'
  private offerGlasses: ICartItem[] = []
  private showFrameSelection: boolean = false

  private get date () {
    return new Date()
      .toJSON()
      .slice(0, 10)
      .split('-')
      .reverse()
      .join('/')
  }
  private get age () {
    return this.$store.state.matrix.age
  }

  private get clientName () {
    return this.$store.state.matrix.name || '-'
  }
  private get optician () {
    return this.$store.state.data.optician.name
  }

  private get showPrice (): boolean {
    return this.$store.state.data.optician.showPrices
  }

  private get basketTitle (): string {
    if (this.$store.state.data.optician.basketTitle) {
      return this.$store.state.data.optician.basketTitle
    }
    return ''
  }

  private get lookTwiceCampaign (): boolean {
    if (this.$store.state.data.optician.looktwice) {
      if (this.$store.state.data.optician.looktwice === true) {
        if (this.offerGlasses.length > 0) {
          return true
        }
      }
    }
    return false
  }

  private createDummy (glassId: string, glassName: string, price: number): CartItem {
    const optician = this.$store.state.data.optician

    const type = new GlassType()
    type.description = ''
    type.price = price
    type.id = '2000'
    type.isDefault = true
    type.glassId = ''
    type.hasImpressionist = false
    type.hasDneye = false
    type.options = []
    type.name = ''
    type.subTitle = ''
    type.usps = []
    type.uspValues = []
    type.priceTypeText = optician.priceTypeText
    type.discountPrice = 0
    type.discountScreenPrice = 0
    type.discountPercentage = 0
    type.priceType = optician.priceType
    type.discountTitle = '' // discount
    type.promotionTitle = ''

    const glass = new Glass({
      id: glassId,
      actionPercentage: 0,
      actionTitle: '',
      actionSubTitle: '',
      available: true,
      icon: '',
      informationCode: '',
      isMulti: true,
      isSingle: false,
      glassTypes: [],
      name: glassName,
      readingGlasses: false,
      screenGlasses: false,
      selected: false,
      sportGlasses: false,
      subTitle: '',
      sunglasses: false,
      usps: []
    })

    glass.glassTypes.push(type)
    const item = new CartItem(glass)
    item.id = item.glasses.id

    return item
  }

  private mounted () {
    this.showFrameSelection = true
    // check if cart contains single / multi glass
    const items = this.$store.state.cart.items
    if (items && items.length > 0) {
      const glass = items[0]
      if (glass.glasses.isMulti || glass.glasses.isSingle) {
        let price = 0
        let screenPrice = 0

        // Sun
        if (glass.type.discountPrice && glass.type.discountPrice > 0) {
          price = glass.type.discountPrice
          if (glass.type && glass.type.priceType === 1) {
            price = price / 2
          }

          let sunTitle = this.$t('look_twice_item_sun')
          if (this.$store.state.data.optician.altTitleSun) {
            sunTitle = this.$store.state.data.optician.altTitleSun
          }

          this.offerGlasses.push(this.createDummy(Offer.Sun, sunTitle, price))
        }
        // Screen
        if (glass.type.discountScreenPrice && glass.type.discountScreenPrice > 0) {
          screenPrice = glass.type.discountScreenPrice
          if (glass.type && glass.type.priceType === 1) {
            screenPrice = screenPrice / 2
          }

          let screenTitle = this.$t('look_twice_item_screen')
          if (this.$store.state.data.optician.altTitleSun) {
            screenTitle = this.$store.state.data.optician.altTitleScreen
          }

          this.offerGlasses.push(this.createDummy(Offer.Screen, screenTitle, screenPrice))
        }
      }
    }
  }
}
